import React, { useState } from 'react';
import { Search, Sparkles, ArrowRight } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { motion } from 'framer-motion';

const FilterBar = ({ initialQuery = "" }) => {
  const [query, setQuery] = useState(initialQuery);
  const navigate = useNavigate();

  const handleSearch = (e) => {
    e.preventDefault();
    if (query.trim()) {
      navigate(`/search?q=${encodeURIComponent(query)}`);
    }
  };

  return (
    <motion.form 
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ delay: 0.2, duration: 0.6 }}
      onSubmit={handleSearch}
      className="relative w-full max-w-2xl mx-auto group"
    >
      <div className="relative flex items-center">
        <div className="absolute left-6 text-primary/40 group-focus-within:text-primary transition-colors">
          <Sparkles size={20} />
        </div>
        <input
          type="text"
          value={query}
          onChange={(e) => setQuery(e.target.value)}
          placeholder="Describe your dream villa (e.g., 'Sunset overwater with slide')"
          className="w-full h-16 pl-14 pr-16 bg-white/90 backdrop-blur-xl border border-white/40 rounded-full shadow-[0_8px_30px_rgb(0,0,0,0.04)] text-lg placeholder:text-muted-foreground/60 focus:outline-none focus:ring-2 focus:ring-accent/50 transition-all font-body text-primary"
          data-testid="search-input"
        />
        <button 
          type="submit"
          className="absolute right-2 top-2 h-12 w-12 bg-primary rounded-full flex items-center justify-center text-white hover:bg-primary/90 transition-all shadow-md group-focus-within:scale-105"
          data-testid="search-submit"
        >
          <ArrowRight size={20} />
        </button>
      </div>
      <div className="mt-3 flex gap-3 justify-center text-xs text-muted-foreground/80 font-medium tracking-wide">
        <span>Try:</span>
        <button type="button" onClick={() => setQuery("Romantic overwater villa with pool")} className="hover:text-primary transition-colors underline decoration-dotted">Romantic Overwater</button>
        <button type="button" onClick={() => setQuery("Family beach villa with kids club")} className="hover:text-primary transition-colors underline decoration-dotted">Family Beach</button>
      </div>
    </motion.form>
  );
};

export default FilterBar;
